export const PIN_KEYS = {
  BIO_PIN_IN_USE: 'BIO_PIN_IN_USE',
  BIO_PIN_DISABLED: 'BIO_PIN_DISABLED',
}

export const SHOW_COST_CENTER_KEY = 'showCostCenter'
export const SHOW_TOP_CALENDAR_SHIFTS_KEY = 'showTopCalendarShifts'
